var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowTurnLeftCanvas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    height: 80,
    width: 80,
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFF;stroke:#FFF;stroke-width:1.5;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12,12) scale(0.7)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.6,72.1V44.9c0-0.5,0-0.9,0-1.4l0-0.1c0-0.6-0.1-1.2-0.2-1.8c0-0.1,0-0.2,0-0.2c-0.1-0.6-0.3-1.1-0.5-1.6 c-1.3-3.5-4.7-5.9-8.7-5.9l-9,0L33,45.2L14.2,26.5L33,7.9v11.7l9.7-0.1c1.3,0,2.5,0.1,3.7,0.3c0.6,0.1,1.3,0.2,1.9,0.4l0,0 c0.8,0.2,1.6,0.5,2.4,0.8c0.4,0.1,0.9,0.3,1.3,0.5c0.4,0.2,0.7,0.3,1,0.5c0.9,0.4,1.8,0.9,2.6,1.5c0.1,0.2,0.3,0.3,0.5,0.4 c0.5,0.3,0.9,0.7,1.3,1c0.3,0.2,0.6,0.5,0.8,0.7c0.3,0.2,0.6,0.5,0.8,0.7c1.1,1.2,2.1,2.4,3,3.8c1.4,2.2,2.5,4.6,3.1,7.2 c0.2,0.9,0.4,1.9,0.5,2.8c0.2,0.9,0.2,2.6,0.2,2.6v29.4H51.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTurnLeftCanvas);
export default __webpack_public_path__ + "static/media/arrow-turn-left-canvas.043816747be41ef72a375dcc3dadab6d.svg";
export { ForwardRef as ReactComponent };